import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import bsCustomFileInput from "bs-custom-file-input";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { DataService } from "src/app/shared/Services/data.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-deportment",
  templateUrl: "./deportment.component.html",
  styleUrls: ["./deportment.component.scss"],
})
export class DeportmentComponent implements OnInit {
  submit: boolean = false;
  showDowntime: boolean = false;
  custId: any = "";
  loginRole: any = "";
  shiftsArr: any = [];
  shiftsArr2: any = [];
  planneddowntime: FormArray;
  validationform: FormGroup;
  selectValue: any;
  selectValue2: any = [];
  plannedInterval = [];
  plannedInterval2: any = [];
  disabledTime = ["Select Time"];
  selectedOptionIndex: number = -1;
  selectedShiftOptionIndex: number = -1;
  shiftInterval = [];
  errmsg: String;
  isAdd: boolean = false;
  is24hr: boolean = false;
  showadd: boolean = true;
  isAddData: boolean = false;
  add: boolean = false;
  starttime;
  endtime;
  isEdit: boolean = false;
  id: "";
  delShiftId;
  shiftsFormArray: FormArray;
  breadCrumbItems: Array<{}>;
  startingTime: any;
  endingTime: any;
  initalClick: boolean = false;
  is24: boolean = true;
  departmentName: any;
  isDepartmentShift: boolean = false;
  userData: any;
  custId2: any;
  departshiftData: any = [];
  selectedDepartShift = "New";
  constructor(
    public formBuilder: FormBuilder,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private dataservice: DataService,
    private toastr: ToastrService
  ) {
    let userDetails = JSON.parse(sessionStorage.getItem("currentUser"));
    let user = userDetails["user"];
    this.loginRole = user["role"];
    this.validationform = this.formBuilder.group({
      shifts: this.formBuilder.array([]), // Initialize FormArray for shifts
    });
    this.userData = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId2 = this.userData["user"]["custId"];
  }

  ngOnInit() {
    this.breadCrumbItems = [
      { label: "Configuration" },
      { label: "Department", active: true },
    ];
    bsCustomFileInput.init();
    this.custId = this.route.snapshot.paramMap.get("id");
    if (this.custId) {
      this.getCustShiftDetails(this.custId);
    } else {
      this.getshiftDetails();
    }
  }

  getCustShiftDetails(custId) {
    this.dataservice
      .get(`department?custId=${custId}`)
      .subscribe((res: any) => {
        if (res.data.length != 0) {
          if (res.data.length != 0) {
            this.is24hr = true;
            this.shiftsArr = res["data"];
            this.shiftsArr2 = res["data"].filter(
              (val) => val["isDepartmentShift"] == true
            );
            this.selectValue = this.getTimeIntervals("00:00", "23:59");
          } else {
            this.is24hr = false;
            this.selectValue = this.getTimeIntervals("00:00", "23:59");
            this.errmsg = "Please configure shifts";
          }
        } else {
          this.shiftsArr = [];
          this.shiftsArr2 = [];
          this.is24hr = false;
          this.selectValue = this.getTimeIntervals("00:00", "23:59");
          this.selectValue2.push(this.selectValue);
          this.errmsg = "Please configure shifts";
        }
        (error) => {
          this.selectValue = this.getTimeIntervals("00:00", "23:59");
          this.errmsg = "Please configure shifts";
        };
      });
  }

  getshiftDetails() {
    this.shiftsArr = [];
    this.shiftsArr2 = [];
    this.dataservice.get(`department`).subscribe((res: any) => {
      if (res) {
        this.is24hr = true;
        this.shiftsArr = res["data"];
        this.shiftsArr2 = res["data"].filter(
          (val) => val["isDepartmentShift"] == true
        );
        this.selectValue = this.getTimeIntervals("00:00", "23:59");
        this.selectValue2.push(this.selectValue);
      }
    });
  }
  onShiftToggle(): void {
    this.isDepartmentShift = !this.isDepartmentShift;
    this.initializeForm();
  }

  onShiftSelect(selectedShift: any) {
    if (selectedShift !== "New") {
      this.isAddData = true;

      let data = this.shiftsArr.find(
        (val) => val.departmentName == selectedShift
      );
      this.existting(data, "edit");
    } else {
      this.isAddData = true;

      this.validationform.reset();
      this.shiftsFormArray = this.validationform.get("shifts") as FormArray;
      this.shiftsFormArray.clear();
      this.selectValue = [];
      this.selectValue2 = [];
      this.initializeForm();
    }
  }
  existting(data, val) {
    // this.deviceId = data.id
    // this.departmentName = data.departmentName;
    // this.isDepartmentShift = data.isDepartmentShift;
    this.isEdit = true;
    if (this.isDepartmentShift) {
      this.same = false;
      this.initializeForm();
      this.plannedInterval = [];

      const shiftArray = this.validationform.get("shifts") as FormArray;
      shiftArray.clear();

      data.shiftData.forEach((data, index) => {
        const {
          usershiftId,
          shiftName,
          startTime,
          endTime,
          checkplanned,
          planneddowntime,
        } = data;
        this.endtime = moment(endTime, "HH:mm:ss")
          .add(1, "seconds")
          .format("HH:mm");
        this.starttime = moment(startTime, "HH:mm:ss").format("HH:mm");
        this.selectValue2[index] = this.getTimeIntervals("00:00", "23:59");
        this.plannedInterval2[index] = this.getTimeIntervals(
          moment(startTime, "HH:mm:ss").format("HH:mm"),
          moment(endTime, "HH:mm:ss").add(1, "seconds").format("HH:mm")
        );
        this.shiftInterval = this.getTimeIntervals("00:00", "23:59");
        let startFormatted = moment(startTime, "HH:mm:ss").format("HH:mm");
        let endFormatted = moment(endTime, "HH:mm:ss")
          .add(1, "seconds")
          .format("HH:mm");

        let shiftFormGroup = this.formBuilder.group({
          usershiftId: [{ value: usershiftId || "", disabled: true }], // Disable on initialization
          shiftName: [shiftName || "", Validators.required],
          startTime: [
            { value: startFormatted, disabled: true },
            Validators.required,
          ],
          endTime: [
            { value: endFormatted, disabled: true },
            Validators.required,
          ],
          checkplanned: [checkplanned || false],
          planneddowntime: this.formBuilder.array([]),
        });

        if (planneddowntime && planneddowntime.length > 0) {
          const plannedArray = shiftFormGroup.get(
            "planneddowntime"
          ) as FormArray;
          planneddowntime.forEach((item) => {
            plannedArray.push(
              this.formBuilder.group({
                downtimename: [item.downtimename, Validators.required],
                duration: [
                  moment(item.duration, "HH:mm:ss")
                    .add(1, "seconds")
                    .format("HH:mm"),
                  Validators.required,
                ],
                plannedstarttime: [
                  moment(item.plannedstarttime, "HH:mm:ss").format("HH:mm"),
                  Validators.required,
                ],
                plannedendtime: [
                  moment(item.plannedendtime, "HH:mm:ss")
                    .add(1, "seconds")
                    .format("HH:mm"),
                  Validators.required,
                ],
              })
            );
          });
        }

        shiftArray.push(shiftFormGroup);
        if (this.loginRole == "CUSTOMER") {
          this.custId = data.custId;
          this.disableAllRows2(index);
        } else {
          this.disablePreviousRows(index);
          // this.disableAllRows2(index);
        }
        let datas = {
          checked: checkplanned,
        };
        let target2 = {
          target: datas,
        };
        this.downtimeAdd(target2, index);
      });
      if (val === "edit") {
        this.isAdd = true;
      } else if (val === "view") {
        this.isAdd = false;
      }
    } else {
      this.isAdd = true;
      this.initializeForm();
    }
  }

  initializeForm() {
    if (this.isDepartmentShift == true) {
      this.selectValue = this.getTimeIntervals("00:00", "23:59");
      this.selectValue2.push(this.selectValue);
      this.initalClick = true;
      this.shiftsFormArray = this.validationform.get("shifts") as FormArray;
      this.shiftsFormArray.push(this.createShiftFormGroup());
    } else {
      this.initalClick = true;
      this.shiftsFormArray = this.validationform.get("shifts") as FormArray;
      this.shiftsFormArray.clear(); // Remove any existing form groups
    }
  }

  createShiftFormGroup(): FormGroup {
    const usershiftId =
      this.shiftsFormArray.length > 0
        ? `SH${this.shiftsFormArray.length + 1}`
        : "SH1";

    return this.formBuilder.group({
      usershiftId: [
        usershiftId,
        [Validators.required, Validators.pattern("[a-zA-Z0-9]+")],
      ],
      shiftName: ["", [Validators.required]],
      startTime: ["", [Validators.required]],
      endTime: ["", [Validators.required]],
      checkplanned: [false],
      planneddowntime: this.formBuilder.array([]),
    });
  }

  downtimeAdd(e, index) {
    if (e?.target?.checked) {
      this.showadd = true;
      if (this.isEdit) {
        this.validationform.get(["shifts", index, "startTime"])?.enable();
        this.validationform.get(["shifts", index, "endTime"])?.enable();
        this.starttime =
          this.validationform.value["shifts"][index]["startTime"];
        this.endtime = this.validationform.value["shifts"][index]["endTime"];
        let lastIndex = this.shiftsFormArray.value.length - 1;
        this.endingTime = this.shiftsFormArray.value[lastIndex].endTime;
        this.startingTime = this.shiftsFormArray.value[0].startTime;
        if (this.shiftsFormArray.value.length !== 1) {
          this.plannedInterval = this.getTimeIntervals(
            this.starttime,
            this.endtime
          );
        } else {
          this.plannedInterval = this.getTimeIntervals(
            this.starttime,
            moment(this.shiftsFormArray.value[0]["endTime"], "HH:mm")
              .subtract(1, "minute")
              .format("HH:mm")
          );
        }
        this.plannedInterval2[index] = this.plannedInterval2[index] || [];
        this.plannedInterval2[index] = [];
        this.plannedInterval2[index].push(...this.plannedInterval);

        this.shiftInterval = this.getTimeIntervals("00:00", "23:59");
      } else {
        this.validationform.get(["shifts", index, "startTime"])?.enable();
        this.validationform.get(["shifts", index, "endTime"])?.enable();
        this.starttime =
          this.validationform.value["shifts"][index]["startTime"];
        this.endtime = this.validationform.value["shifts"][index]["endTime"];

        let lastIndex = this.shiftsFormArray.value.length - 1;
        this.endingTime = this.shiftsFormArray.value[lastIndex].endTime;
        this.startingTime = this.shiftsFormArray.value[0].startTime;

        this.plannedInterval = this.getTimeIntervals(
          this.starttime,
          this.endtime
        );
        this.plannedInterval2[index] = this.plannedInterval2[index] || [];
        this.plannedInterval2[index] = [];
        this.plannedInterval2[index].push(...this.plannedInterval);

        this.shiftInterval = this.getTimeIntervals("00:00", "23:59");
      }

      this.validationform.get(["shifts", index, "startTime"])?.disable();
      this.validationform.get(["shifts", index, "endTime"])?.disable();
    } else {
      if (this.isEdit) {
        this.validationform.get(["shifts", index, "startTime"])?.disable();
        this.validationform.get(["shifts", index, "endTime"])?.disable();
      } else {
        if (this.shiftsFormArray.value.length === 1) {
          this.validationform.get(["shifts", index, "startTime"])?.enable();
          this.validationform.get(["shifts", index, "endTime"])?.enable();
        }

        //  else {
        //   this.validationform.get(["shifts", index, "endTime"])?.enable();
        // }
      }

      this.plannedInterval = [];
      this.plannedInterval2 = this.removeIndex(this.plannedInterval2, index);
      const plannedarray = this.validationform.get([
        "shifts",
        index,
        "planneddowntime",
      ]) as FormArray;
      while (plannedarray.length !== 0) {
        plannedarray.removeAt(0);
      }

      this.showadd = true;
    }
  }

  removeIndex(data, index) {
    if (index >= 0 && index < data.length) {
      data.splice(index, 1);
    }
    return data;
  }

  get form() {
    return this.validationform.controls;
  }

  save() {
    this.submit = true;
    if (!this.departmentName || this.departmentName.trim() === "") {
      return;
    }
    if (!this.isEdit) {
      let finalobj = {
        departmentName: this.departmentName,
        custId: this.custId ? this.custId : this.custId2,
        isDepartmentShift: this.isDepartmentShift,
      };
      this.dataservice.post(`department`, finalobj).subscribe(
        (res) => {
          this.toastr.success("Shifts saved successfully!");
          this.cancel2();
        },
        (error) => {
          this.toastr.error(error.message);
        }
      );
    } else {
      if (this.isAddData) {
        let finalobj = {
          departmentName: this.departmentName,
          custId: this.custId ? this.custId : this.custId2,
          isDepartmentShift: this.isDepartmentShift,
        };
        this.dataservice.post(`department`, finalobj).subscribe(
          (res) => {
            this.toastr.success("Shifts saved successfully!");
            this.cancel2();
          },
          (error) => {
            this.toastr.error(error.message);
          }
        );
      } else {
        let finalobj = {
          departmentName: this.departmentName,
          custId: this.custId ? this.custId : this.custId2,
          isDepartmentShift: this.isDepartmentShift,
        };
        this.dataservice.put(`department/${this.deviceId}`, finalobj).subscribe(
          (res) => {
            this.toastr.success("Shifts saved successfully!");
            this.cancel2();
          },
          (error) => {
            this.toastr.error(error.message);
          }
        );
      }
    }
  }

  createPlannedDowntimeGroup(): FormGroup {
    return this.formBuilder.group({
      downtimename: ["", Validators.required],
      duration: ["", Validators.required],
      plannedstarttime: ["", Validators.required],
      plannedendtime: ["", Validators.required],
    });
  }

  get shiftForms() {
    return this.validationform.get("shifts") as FormArray;
  }

  saveAllShifts() {
    this.submit = true;
    if (this.validationform.invalid) {
      return this.validationform.controls;
    }

    if (!this.departmentName || this.departmentName.trim() === "") {
      return;
    }
    if (this.validationform.valid) {
      if (!this.isEdit) {
        this.validationform.enable();
        let finalobj = {
          departmentName: this.departmentName,
          custId: this.custId ? this.custId : this.custId2,
          isDepartmentShift: this.isDepartmentShift,
          shiftData: this.validationform.value.shifts,
        };
        this.dataservice.post(`department`, finalobj).subscribe(
          (res) => {
            this.toastr.success("Shifts saved successfully!");
            this.cancel();
          },
          (error) => {
            this.toastr.error(error.message);
          }
        );
      } else {
        if (this.isAddData) {
          this.validationform.enable();
          let finalobj = {
            departmentName: this.departmentName,
            custId: this.custId ? this.custId : this.custId2,
            isDepartmentShift: this.isDepartmentShift,
            shiftData: this.validationform.value.shifts,
          };
          this.dataservice.post(`department`, finalobj).subscribe(
            (res) => {
              this.toastr.success("Shifts saved successfully!");
              this.cancel();
            },
            (error) => {
              this.toastr.error(error.message);
            }
          );
        } else {
          this.validationform.enable();
          let finalobj = {
            departmentName: this.departmentName,
            custId: this.custId ? this.custId : this.custId2,
            isDepartmentShift: this.isDepartmentShift,
            shiftData: this.validationform.value.shifts,
          };
          this.dataservice
            .put(`department/${this.deviceId}`, finalobj)
            .subscribe(
              (res) => {
                this.toastr.success("Shifts saved successfully!");
                this.cancel();
              },
              (error) => {
                this.toastr.error(error.message);
              }
            );
        }
      }
    } else {
      this.toastr.error("Please fill all required fields!");
    }
  }
  isLimit: boolean = false;
  plannedendTime(e, index) {
    let shiftEndtime;
    let lastIndexEnd;
    let diffval;
    let planneddowntime =
      this.validationform.value["shifts"][index]["planneddowntime"];

    if (planneddowntime.length) {
      if (this.isEdit) {
        shiftEndtime = moment(this.endtime, "HH:mm").format("HH:mm");
      } else {
        shiftEndtime = this.endtime;
      }
      let lastIndex = planneddowntime.length - 1;
      let lastIndexprevIndex;

      let lastIndexDuration = planneddowntime[lastIndex].duration;
      let lastIndexStart = planneddowntime[lastIndex].plannedstarttime;

      if (lastIndexDuration && lastIndexStart) {
        lastIndexEnd = this.addHHMM(lastIndexDuration, lastIndexStart);
        diffval = this.subHHMM(lastIndexDuration, shiftEndtime);

        const time1 = moment(lastIndexEnd, "HH:mm");
        const time2 = moment(shiftEndtime, "HH:mm");
        const time3 = moment(diffval, "HH:mm");
        const time4 = moment(lastIndexStart, "HH:mm");

        if (time1.isBefore(time2) && time1.isAfter(time4)) {
          this.isLimit = false;
        } else {
          if (time2.isBefore(time4)) {
            this.isLimit = false;
          } else {
            this.isLimit = true;
            this.toastr.info("Given time is exid than shift time");
          }
        }
        if (planneddowntime.length && planneddowntime.length >= 2) {
          lastIndexprevIndex = planneddowntime.length - 2;
          let lastIndexPreviewEnd =
            planneddowntime[lastIndexprevIndex].plannedendtime;
          const time5 = moment(lastIndexPreviewEnd, "HH:mm");
          // if (time4.isBefore(time5) || time4.isSame(time5)) {
          //   this.isLimit = true;
          //   this.toastr.info(
          //     `The selected time is earlier than the last recorded downtime. Please choose a time after ${lastIndexPreviewEnd}.`
          //   );
          // }
        }
        const analogArray = this.validationform.get([
          "shifts",
          index,
          "planneddowntime",
        ]) as FormArray;
        const lastItem = analogArray.at(analogArray.length - 1);
        lastItem.get("plannedendtime").setValue(lastIndexEnd);
        if (lastIndexEnd == shiftEndtime) {
          this.showadd = false;
        } else {
          this.showadd = true;
        }
      }
    } else {
      this.isLimit = false;
    }
  }

  getTimeIntervals(start, end) {
    let startTime = moment(start, "HH:mm");
    let endTime = moment(end, "HH:mm");
    if (endTime.isBefore(startTime)) {
      endTime.add(1, "day");
    }
    let timeStops = [];
    while (startTime <= endTime) {
      timeStops.push(moment(startTime).format("HH:mm"));
      startTime.add(1, "minutes");
    }
    return timeStops;
  }
  addNewShift() {
    this.is24 = true;
    this.shiftsFormArray.push(this.createShiftFormGroup());
    if (this.shiftsFormArray.value.length) {
      let lastIndex;
      let lastIndexDuration;
      let lastIndexStart;

      if (this.shiftsFormArray.value.length === 2) {
        lastIndex = this.shiftsFormArray.value.length - 2;
        this.validationform.get(["shifts", lastIndex, "startTime"])?.enable();
        this.validationform.get(["shifts", lastIndex, "endTime"])?.enable();
        this.startingTime = this.shiftsFormArray.value[0].startTime;
        this.endingTime = this.shiftsFormArray.value[lastIndex].endTime;
        this.validationform.get(["shifts", lastIndex, "startTime"])?.disable();
        this.validationform.get(["shifts", lastIndex, "endTime"])?.disable();
      } else if (this.shiftsFormArray.value.length > 2) {
        lastIndex = this.shiftsFormArray.value.length - 2;
        this.validationform.get(["shifts", 0, "startTime"])?.enable();
        this.validationform.get(["shifts", lastIndex, "endTime"])?.enable();
        this.startingTime = this.shiftsFormArray.value[0].startTime;
        this.endingTime = this.shiftsFormArray.value[lastIndex].endTime;
        this.validationform.get(["shifts", 0, "startTime"])?.disable();
        this.validationform.get(["shifts", lastIndex, "endTime"])?.disable();
      }

      this.validationform.get(["shifts", lastIndex, "startTime"])?.disable();
      this.validationform.get(["shifts", lastIndex, "endTime"])?.disable();

      (lastIndexDuration = moment(this.endingTime, "HH:mm")
        // .add(1, "minutes")
        .format("HH:mm")),
        (lastIndexStart = moment(this.startingTime, "HH:mm")
          // .subtract(1, "minutes")
          .format("HH:mm"));
      const lastShiftGroup = this.shiftsFormArray.at(
        this.shiftsFormArray.length - 1
      ) as FormGroup;
      lastShiftGroup.get("startTime")?.setValue(lastIndexDuration);
      lastShiftGroup.get("startTime")?.disable();
      this.selectValue2.push(
        this.getTimeIntervals(lastIndexDuration, lastIndexStart)
      );
    }
  }

  same: boolean = true;
  check24(data) {
    if (this.shiftsFormArray.value.length === 1) {
      // if (
      //   moment(data, "HH:mm").add(1, "minute").format("HH:mm") ==
      //   this.shiftsFormArray.value[0]["startTime"]
      // ) {
      //   this.toastr.info("You Selected 24 hr");
      //   this.is24 = true;
      //   this.same = false;
      // } else
      if (this.shiftsFormArray.value[0]["startTime"] == data) {
        this.toastr.info("You Selected 24 hr");
        this.is24 = true;
        this.same = false;
      } else {
        this.same = true;
        this.is24 = false;
      }
    } else {
      if (this.add) {
        this.startingTime = this.shiftsFormArray.at(0).get("startTime")?.value;
      }
      this.validationform
        .get(["shifts", this.shiftsFormArray.value.length - 1, "startTime"])
        ?.enable();
      if (
        moment(data, "HH:mm")
          // .add(1, "minute")
          .format("HH:mm") == this.startingTime
      ) {
        this.toastr.info("You Selected 24 hr");
        this.is24 = true;
        this.same = false;
      } else if (
        this.shiftsFormArray.value[this.shiftsFormArray.value.length - 1][
          "startTime"
        ] == data
      ) {
        this.validationform
          .get(["shifts", this.shiftsFormArray.value.length - 1, "startTime"])
          ?.disable();
        this.toastr.info("You Selected 24 hr");
        this.is24 = true;
        this.same = true;
      } else {
        this.is24 = false;
        this.same = true;
      }
      this.validationform
        .get(["shifts", this.shiftsFormArray.value.length - 1, "startTime"])
        ?.disable();
    }
  }

  removeLastShift() {
    this.is24 = false;
    this.same = true;
    if (this.shiftsFormArray.length > 1) {
      this.shiftsFormArray.removeAt(this.shiftsFormArray.length - 1);
      const lastIndexData = this.shiftsFormArray.length - 1;
      const lastFormGroup = this.shiftsFormArray.at(lastIndexData) as FormGroup;
      let lastIndex = this.shiftsFormArray.value.length - 1;
      if (lastFormGroup && lastIndex != 0) {
        lastFormGroup.get("startTime")?.disable();
      } else {
        this.validationform.get(["shifts", lastIndex, "startTime"])?.enable();
      }

      this.validationform.get(["shifts", lastIndex, "endTime"])?.enable();
      this.selectValue2.pop();
    } else {
      this.toastr.warning("At least one shift is required!");
    }
  }
  addPlannedDowntime(shiftIndex: number) {
    const plannedDowntimeArray = this.shiftsFormArray
      .at(shiftIndex)
      .get("planneddowntime") as FormArray;
    plannedDowntimeArray.push(this.createPlannedDowntimeGroup());
    this.disablePreviousRows(shiftIndex);
  }

  getInterval(index) {
    // this.plannedInterval2[0] = [];
    // this.plannedInterval2[0].push(...this.plannedInterval);
    this.validationform.get(["shifts", index, "startTime"])?.enable();
    this.validationform.get(["shifts", index, "endTime"])?.enable();
    this.starttime = this.validationform.value["shifts"][index]["startTime"];
    this.endtime = this.validationform.value["shifts"][index]["endTime"];
    if (this.shiftsFormArray.value.length !== 1) {
      this.plannedInterval = this.getTimeIntervals(
        this.starttime,
        this.endtime
      );
    } else {
      this.plannedInterval = this.getTimeIntervals(
        this.shiftsFormArray.value[0]["startTime"],
        moment(this.shiftsFormArray.value[0]["endTime"], "HH:mm")
          .subtract(1, "minute")
          .format("HH:mm")
      );
    }
    // this.plannedInterval2[index] = this.plannedInterval2[index] || [];
    this.plannedInterval2[index] = [];
    this.plannedInterval2[index].push(...this.plannedInterval);

    let planneddowntime =
      this.validationform.value["shifts"][index]["planneddowntime"];
    if (planneddowntime.length) {
      let lastIndex = planneddowntime.length - 1;
      let lastIndexDuration = planneddowntime[lastIndex].duration;
      let lastIndexStart = planneddowntime[lastIndex].plannedstarttime;
      let lastIndexEnd = this.addHHMM(lastIndexDuration, lastIndexStart);
      this.validationform.value["shifts"][index]["planneddowntime"][lastIndex][
        "plannedendtime"
      ] = lastIndexEnd;
      let indexofplannedtime = this.plannedInterval.indexOf(lastIndexEnd);
      this.selectedOptionIndex = indexofplannedtime;
    } else {
      this.selectedOptionIndex = -1;
    }
    this.validationform.get(["shifts", index, "startTime"])?.disable();
    this.validationform.get(["shifts", index, "endTime"])?.disable();
  }

  isOptionDisabled(index: number): boolean {
    return index <= this.selectedOptionIndex;
  }

  isShiftOptionDisabled(index: number): boolean {
    return index <= this.selectedShiftOptionIndex;
  }

  removeRow(index, index2) {
    this.isLimit = false;
    let lastIndex;
    (<FormArray>(
      this.validationform.get(["shifts", index, "planneddowntime"])
    )).removeAt(index2);

    const plannedArray = this.validationform.get([
      "shifts",
      index,
      "planneddowntime",
    ]) as FormArray;

    let lastIndexObject =
      plannedArray["value"][plannedArray["value"].length - 1];
    if (lastIndexObject?.plannedendtime != this.endtime) {
      this.showadd = true;
    }
    if (plannedArray["value"].length == 0) {
      this.selectedOptionIndex = -1;
    } else if (plannedArray["value"].length == 1) {
      lastIndex = 1;
      let indexofplannedtime = this.plannedInterval.indexOf(this.starttime);
      this.selectedOptionIndex = indexofplannedtime;
    } else {
      lastIndex = plannedArray["value"].length - 1;
      let previousObject = plannedArray["value"][lastIndex - 1];

      let indexofplannedtime = this.plannedInterval.indexOf(
        previousObject.plannedendtime
      );
      this.selectedOptionIndex = indexofplannedtime;
    }
    this.disablePreviousRows(index);
  }
  addFun() {
    this.add = true;
  }
  cancel() {
    this.departmentName = "";
    this.selectedDepartShift = "New";
    this.isDepartmentShift = false;
    this.initalClick = false;
    this.is24 = true;
    this.selectValue2 = [];
    this.plannedInterval2 = [];
    this.startingTime = "";
    this.endingTime = "";
    this.isAdd = false;
    this.isEdit = false;
    this.submit = false;
    this.isAddData = false;
    this.validationform.reset();
    this.shiftsFormArray.clear();
    if (this.loginRole == "SUPERADMIN") {
      this.getCustShiftDetails(this.custId);
    } else {
      this.getshiftDetails();
    }
  }
  cancel2() {
    this.departmentName = "";
    this.selectedDepartShift = "New";
    (this.departmentName = ""), (this.isDepartmentShift = false);
    this.initalClick = false;
    this.isAdd = false;
    this.isEdit = false;
    this.submit = false;
    this.isAddData = false;
    if (this.loginRole == "SUPERADMIN") {
      this.getCustShiftDetails(this.custId);
    } else {
      this.getshiftDetails();
    }
  }
  closeView() {
     this.initalClick = false;
  }
  addHHMM(time1: string, time2: string): string {
    if (time1 != undefined && time2 != undefined) {
      const [hours1, minutes1] = time1.split(":").map(Number);
      const [hours2, minutes2] = time2.split(":").map(Number);
      let totalMinutes = (hours1 + hours2) * 60 + minutes1 + minutes2;
      totalMinutes = totalMinutes % (24 * 60);
      if (totalMinutes < 0) {
        totalMinutes += 24 * 60;
      }
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      const result = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}`;
      return result;
    }
  }

  subHHMM(st, edt) {
    // Convert HH:MM format to minutes
    const [stHours, stMinutes] = st.split(":").map(Number);
    const [edtHours, edtMinutes] = edt.split(":").map(Number);

    // Convert start and end time to total minutes
    const startMinutes = stHours * 60 + stMinutes;
    const endMinutes = edtHours * 60 + edtMinutes;

    // Calculate difference in minutes
    const diffMinutes = endMinutes - startMinutes;

    // Convert minutes back to HH:MM format
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    // Format result as HH:MM
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  }
  disablePreviousRows(index: number): void {
    const shifts = this.validationform.get("shifts") as FormArray;
    if (shifts && shifts.controls[index]) {
      const plannedDowntime = shifts.controls[index].get(
        "planneddowntime"
      ) as FormArray;

      if (plannedDowntime && plannedDowntime.length > 0) {
        plannedDowntime.controls.forEach((row, i) => {
          if (i < plannedDowntime.length - 1) {
            row.get("duration")?.disable();
            row.get("plannedstarttime")?.disable();
          } else {
            row.get("duration")?.enable();
            row.get("plannedstarttime")?.enable();
          }
        });
      }
    }
  }
  disableAllRows2(index: number): void {
    const shifts = this.validationform.get("shifts") as FormArray;
    if (shifts && shifts.controls[index]) {
      const plannedDowntime = shifts.controls[index].get(
        "planneddowntime"
      ) as FormArray;

      if (plannedDowntime && plannedDowntime.length > 0) {
        plannedDowntime.controls.forEach((row) => {
          row.get("duration")?.disable();
          row.get("plannedstarttime")?.disable();
        });
      }
    }
  }

  // disablePreviousRows(index): void {
  //   const rows = this.validationform.get([
  //     "shifts",
  //     index,
  //     "planneddowntime",
  //   ]) as FormArray;
  //   const lastRowIndex = rows?.length - 1;
  //   rows?.controls.forEach((row, index) => {
  //     const control = row;
  //     if (control) {
  //       if (index < lastRowIndex) {
  //         control.get("duration").disable();
  //         control.get("plannedstarttime").disable();
  //       } else {
  //         control.enable();
  //       }
  //     }
  //   });
  // }

  disableAllRows(): void {
    const rows = this.validationform.get("planneddowntime") as FormArray;
    const lastRowIndex = rows.length - 1;
    rows.controls.forEach((row, index) => {
      const control = row;
      if (control) {
        if (index <= lastRowIndex) {
          control.get("duration").disable();
          control.get("plannedstarttime").disable();
        } else {
          control.enable();
        }
      }
    });
  }

  enableAllControls(): void {
    const rows = this.validationform.get("planneddowntime") as FormArray;
    rows.controls.forEach((row) => {
      row.enable();
    });
  }
  deviceId: any;
  edit(data, val) {
    this.add = false;
    this.deviceId = data.id;
    this.departmentName = data.departmentName;
    this.isDepartmentShift = data.isDepartmentShift;
    this.isEdit = true;
    if (this.isDepartmentShift) {
      this.same = false;
      this.initializeForm();
      this.plannedInterval = [];

      const shiftArray = this.validationform.get("shifts") as FormArray;
      shiftArray.clear();

      data.shiftData.forEach((data, index) => {
        const {
          usershiftId,
          shiftName,
          startTime,
          endTime,
          checkplanned,
          planneddowntime,
        } = data;
        this.endtime = moment(endTime, "HH:mm:ss")
          .add(1, "seconds")
          .format("HH:mm");

        this.starttime = moment(startTime, "HH:mm:ss").format("HH:mm");
        this.selectValue2[index] = this.getTimeIntervals("00:00", "23:59");
        // this.plannedInterval2[index] = this.getTimeIntervals(
        //   moment(startTime, "HH:mm:ss").format("HH:mm"),
        //   moment(endTime, "HH:mm:ss").add(1, "seconds").format("HH:mm")
        // );
        // if (data['shiftData'] && data['shiftData'].length !== 1) {
        //   this.plannedInterval = this.getTimeIntervals(
        //     this.starttime,
        //     this.endtime
        //   );
        // } else {
        //   console.log(this.starttime,this.endtime,"else-------------------!!!!!!!!!!!!!!!!")
        //   this.plannedInterval = this.getTimeIntervals(
        //     this.starttime,
        //     moment(this.endtime, "HH:mm").subtract(1, "minute").format("HH:mm")
        //   );
        // }
        // console.log(this.plannedInterval,"plannedInterval")

        this.shiftInterval = this.getTimeIntervals("00:00", "23:59");
        let startFormatted = moment(startTime, "HH:mm:ss").format("HH:mm");
        let endFormatted = moment(endTime, "HH:mm:ss")
          .add(1, "seconds")
          .format("HH:mm");
        // let endFormatted = moment(endTime, "HH:mm:ss").add(1, "seconds").format("HH:mm");

        let shiftFormGroup = this.formBuilder.group({
          usershiftId: [{ value: usershiftId || "", disabled: true }], // Disable on initialization
          shiftName: [shiftName || "", Validators.required],
          startTime: [
            { value: startFormatted, disabled: true },
            Validators.required,
          ],
          endTime: [
            { value: endFormatted, disabled: true },
            Validators.required,
          ],
          checkplanned: [checkplanned || false],
          planneddowntime: this.formBuilder.array([]),
        });
        if (planneddowntime && planneddowntime.length > 0) {
          const plannedArray = shiftFormGroup.get(
            "planneddowntime"
          ) as FormArray;
          planneddowntime.forEach((item) => {
            plannedArray.push(
              this.formBuilder.group({
                downtimename: [item.downtimename, Validators.required],
                duration: [
                  moment(item.duration, "HH:mm:ss")
                    .add(1, "seconds")
                    .format("HH:mm"),
                  Validators.required,
                ],
                plannedstarttime: [
                  moment(item.plannedstarttime, "HH:mm:ss").format("HH:mm"),
                  Validators.required,
                ],
                plannedendtime: [
                  moment(item.plannedendtime, "HH:mm:ss")
                    .add(1, "seconds")
                    .format("HH:mm"),
                  Validators.required,
                ],
              })
            );
          });
        }

        shiftArray.push(shiftFormGroup);
        if (this.loginRole == "CUSTOMER") {
          this.custId = data.custId;
          this.disableAllRows2(index);
        } else {
          this.disablePreviousRows(index);
          // this.disableAllRows2(index);
        }
        let datas = {
          checked: checkplanned,
        };
        let target2 = {
          target: datas,
        };
        this.downtimeAdd(target2, index);
      });
      if (val === "edit") {
        this.isAdd = true;
      } else if (val === "view") {
        this.isAdd = false;
      }
    } else {
      this.isAdd = true;
      this.initializeForm();
    }
  }

  openModal(deletetemp: any, delId: any) {
    this.modalService.open(deletetemp, { centered: true });
    this.delShiftId = delId;
  }
  openModalShift(shiftTemp: any, data: any) {
    this.edit(data, "view");
    this.modalService.open(shiftTemp, { size: "xl", centered: true });
    this.validationform.disable();
  }

  delete(id) {
    if (this.loginRole == "SUPERADMIN") {
      this.dataservice.delete(`department/${id}`).subscribe(
        (res) => {
          if (res) {
            this.modalService.dismissAll();
            this.toastr.success("Department Deleted");
            this.getCustShiftDetails(this.custId);
          }
        },
        (err) => {
          this.toastr.error("Server Unreachable");
        }
      );
    }
  }
}
